import React from 'react';
import { mprnAlertMessageLength, mprnAlertMessageNumber } from '../../config/AppConfigurator';
import { SelectedAddress } from '../SelectedAddress/SelectedAddress';
import { AlertMessage } from '../../components/AlertMessage/AlertMessage';
import PropTypes from 'prop-types';

/* IMPORTING LOCAL STYLES FOR METER POINT REFERENCE NUMBER */ 
import '../../assets/components/MeterPointReferenceNumber.scss';

export const MeterPointReferenceNumber = ({ 
    regexMPRN,
    queryBtnSpinner, 
    mprn='', 
    queryDetails,
    getMPRN, 
    getMeterDataEnquiryDetails, 
    address
}) => {
        return (
            <>
                <div className="mb-3">
                    <label htmlFor="InputMPRN" className="form-label">Search by MPRN</label>
                    <input type="text" className="form-control postcode-input" id="InputMPRN" aria-describedby="MPRNHelp" onChange={event => getMPRN(event)}/>
                </div>
                { mprn.length > 0 && !mprn.match(regexMPRN) &&
                  <div className="postcode-input">
                    <AlertMessage {...mprnAlertMessageLength} />
                  </div>
                }
                { queryDetails && queryDetails[0] && queryDetails[0].gasdetails && queryDetails[0].gasdetails.length === 0 &&
                    <div className="postcode-input">
                      <AlertMessage {...mprnAlertMessageNumber} />
                    </div>
                }
                <button disabled={!mprn.match(regexMPRN)} className="btn btn-primary btn-md meter-point-reference-number-submit-button" onClick={()=>getMeterDataEnquiryDetails()}>
                    { queryBtnSpinner ? 
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        : 
                        'Enquire'
                    }
                </button> 
                <div className="meter-data-enquiry-panel-component-divider"></div>
                  { address && address.length > 0 &&
                    <SelectedAddress selectedAddress={ address }  /> 
                  }
            </>
        );
};

MeterPointReferenceNumber.propTypes = {
    /* 
      regax MPRN for component
    */ 
      regexMPRN: PropTypes.string.isRequired,
    /* 
      address spinner for query button
    */ 
      queryBtnSpinner: PropTypes.bool.isRequired,
    /* 
      mpan for the component
    */ 
      mprn: PropTypes.string.isRequired,
  }
  
  MeterPointReferenceNumber.defaultProps = {
    /*
        default value if regex MPRN core is not given
    */
      regexMPRN: '',
    /*
        default value if address button spinner is not given
    */
      queryBtnSpinner: false,
    /*
        default value if mprn is not given
    */
      mprn: '',
}